export default __webpack_public_path__ + "static/acosta-879ba1b0a4cd4b66147b24e0f8750e95.svg";